import { render } from "./SnapshotZones.vue?vue&type=template&id=603e59fa&scoped=true"
import script from "./SnapshotZones.vue?vue&type=script&lang=js"
export * from "./SnapshotZones.vue?vue&type=script&lang=js"

import "./SnapshotZones.vue?vue&type=style&index=0&id=603e59fa&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos7-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.1.2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603e59fa"]])

export default __exports__